import { Button, OpacitySlide } from "@/components";
import { useAnimateModal, useDesignMaxTheme } from "@/packages";
import { useNewNavigate, usePensionNameValue } from "@/shared/client";
import { FONT } from "@/styles";
import { Box, Center, Text } from "@chakra-ui/react";
import { useInView } from "react-intersection-observer";
import { GuideDetail } from "../guideDetail";
import { TextBanner } from "../textBanner";

export const CTASection = ({ imgList }: { imgList: [{ imgUrl: string }] }) => {
    const pensionName = usePensionNameValue();
    const { onNavigate } = useNewNavigate();
    const { ref, inView } = useInView({ threshold: 0.9, triggerOnce: true, delay: 0.3 });
    const { openModal, setModalContent } = useAnimateModal();
    const { MEDIAS, COLORS } = useDesignMaxTheme();
    const { isLaptop, isMobile } = MEDIAS();

    const engFontSize = isLaptop ? 32 : 48;
    return (
        <Center ref={ref} w="100%" h="100dvh">
            <OpacitySlide imgList={imgList} isControls={false} isScale={false} opacityTime={0.6} time={3000}>
                <TextBanner inView={inView}>
                    <Center rowGap="40px" flexDir="column">
                        <Box textAlign="center">
                            <Text {...FONT("notoSerif", isMobile ? 14 : 20, 500)}>{pensionName}</Text>
                            <Text {...FONT("cormorant", isMobile ? 24 : engFontSize, 700, 1.2)}>OUR PENSION</Text>
                            <Text {...FONT("cormorant", isMobile ? 24 : engFontSize, 700, 1.2)}>OF OLD MEMORIES</Text>
                        </Box>
                        <Box textAlign="center">
                            <Text {...FONT("pretendard", isMobile ? 14 : 16, 300)}>
                                사랑과 우정이 넘치는 우리들의 이야기가 가슴 속에 가득 채워지기를.
                            </Text>
                            <Text {...FONT("pretendard", isMobile ? 14 : 16, 300)}>
                                그윽한 향기 우리 삶의 휴식처에서 언제나 함께 할 수 있는 아름다운 삶의 인연으로 남겨
                                지기를.
                            </Text>
                        </Box>
                        <Center columnGap="16px" width="100%">
                            <Button
                                w={isMobile ? "100%" : "164px"}
                                style={{
                                    backgroundColor: COLORS.gray[500],
                                    height: isMobile ? "40px" : "54px",
                                    color: COLORS.white,
                                    border: `1px solid ${COLORS.gray[500]}`,
                                }}
                                onClick={() => onNavigate({ path: "/reserve" })}
                            >
                                예약하기
                            </Button>
                            <Button
                                w={isMobile ? "100%" : "164px"}
                                style={{ height: isMobile ? "40px" : "54px" }}
                                onClick={() => {
                                    openModal();
                                    setModalContent(<GuideDetail />);
                                }}
                            >
                                이용안내
                            </Button>
                        </Center>
                    </Center>
                </TextBanner>
            </OpacitySlide>
        </Center>
    );
};
